{
  "AGENT_MGMT": {
    "HEADER": "客服",
    "HEADER_BTN_TXT": "添加客服",
    "LOADING": "正在获取客服列表",
    "DESCRIPTION": "客服代表是您的客户支持团队的成员，他们可以查看和回复用户信息。 下面的列表显示您帐户中的所有客服代表。",
    "LEARN_MORE": "角色说明",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "管理员",
      "AGENT": "客服"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "此账号没有关联客服",
      "TITLE": "管理您团队中的客服",
      "DESC": "您可以添加/移除您团队中的客服。",
      "NAME": "姓名：",
      "EMAIL": "电子邮件",
      "STATUS": "状态",
      "ACTIONS": "操作",
      "VERIFIED": "已认证",
      "VERIFICATION_PENDING": "待验证",
      "AVAILABLE_CUSTOM_ROLE": "可自定义角色权限"
    },
    "ADD": {
      "TITLE": "添加客服至您的团队",
      "DESC": "您可以添加能够处理支持您的收件箱的人。",
      "CANCEL_BUTTON_TEXT": "取消",
      "FORM": {
        "NAME": {
          "LABEL": "客服名称",
          "PLACEHOLDER": "请输入客服名称"
        },
        "AGENT_TYPE": {
          "LABEL": "角色",
          "PLACEHOLDER": "请选择一个角色",
          "ERROR": "角色类型必填"
        },
        "EMAIL": {
          "LABEL": "电子邮件地址",
          "PLACEHOLDER": "请输入客服的邮箱地址"
        },
        "SUBMIT": "添加客服"
      },
      "API": {
        "SUCCESS_MESSAGE": "添加客服成功",
        "EXIST_MESSAGE": "该邮箱已被注册，请输入新的电子邮箱",
        "ERROR_MESSAGE": "无法连接服务器，请稍后再试"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "删除",
      "API": {
        "SUCCESS_MESSAGE": "删除客服成功",
        "ERROR_MESSAGE": "无法连接服务器，请稍后再试"
      },
      "CONFIRM": {
        "TITLE": "确认删除",
        "MESSAGE": "您确定要删除吗？ ",
        "YES": "是的，删除 ",
        "NO": "不，保留 "
      }
    },
    "EDIT": {
      "TITLE": "编辑客服信息",
      "FORM": {
        "NAME": {
          "LABEL": "客服名称",
          "PLACEHOLDER": "请输入客服名称"
        },
        "AGENT_TYPE": {
          "LABEL": "角色",
          "PLACEHOLDER": "请选择一个角色",
          "ERROR": "角色必填"
        },
        "EMAIL": {
          "LABEL": "电子邮件地址",
          "PLACEHOLDER": "请输入客服的邮箱地址"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "有效的",
          "PLACEHOLDER": "请选择一个可用状态",
          "ERROR": "需要提供可用性信息"
        },
        "SUBMIT": "编辑客服"
      },
      "BUTTON_TEXT": "编辑",
      "CANCEL_BUTTON_TEXT": "取消",
      "API": {
        "SUCCESS_MESSAGE": "更新客服信息成功",
        "ERROR_MESSAGE": "无法连接服务器，请稍后再试"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "重置密码",
        "ADMIN_SUCCESS_MESSAGE": "一封包含重置密码说明的电子邮件已发送给代理",
        "SUCCESS_MESSAGE": "代理的密码重置成功",
        "ERROR_MESSAGE": "无法连接Woot服务器，请稍后再试"
      }
    },
    "SEARCH_PLACEHOLDER": "搜索客服代表...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "未找到任何结果。"
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "没有",
      "TITLE": {
        "AGENT": "选择客服代表",
        "TEAM": "选择团队"
      },
      "LIST": {
        "NONE": "无"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "未找到客服代表",
          "TEAM": "没有找到团队"
        },
        "PLACEHOLDER": {
          "AGENT": "搜索客服代表",
          "TEAM": "查找团队",
          "INPUT": "查找客服代表"
        }
      }
    }
  }
}
